"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useControlledPopover = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const typestyle_1 = require("typestyle");
const LabelHelpers_1 = require("../LabelHelpers");
const Styles_1 = require("../Styles");
function TriggerElement(_a) {
    var { onClick, testId, title } = _a, props = tslib_1.__rest(_a, ["onClick", "testId", "title"]);
    switch (props.kind) {
        case 'sticker-props':
            return react_1.default.createElement(widgets_1.StickerWidget, Object.assign({}, props, { onClick: onClick, testId: testId }), title || '');
        case 'button-props':
            return react_1.default.createElement(widgets_1.ButtonWidget, Object.assign({}, props, { buttonType: widgets_1.ButtonType.IconOutline, onClick: onClick, testId: testId }));
    }
}
function useControlledPopover(params) {
    const { testId, controlKind, popoverProps, chipProps, iconProps, content: Content, loading, props, onClick, severe, renderMode, } = params;
    const { hidePopoverWhenReferenceIsHidden } = react_1.default.useContext(LabelHelpers_1.LabelButtonContext);
    const controlTestId = `${testId}-controlled-popover`;
    const popoverInstance = react_1.default.useRef(null);
    const [triggerElementProps, setTriggerElementProps] = react_1.default.useState(null);
    const mounted = react_1.default.useRef(false);
    react_1.default.useEffect(() => {
        mounted.current = true;
        return () => {
            mounted.current = false;
        };
    }, []);
    react_1.default.useEffect(() => {
        switch (controlKind) {
            case 'icon':
                setTriggerElementProps(iconProps(severe));
                break;
            case 'chip':
                setTriggerElementProps(chipProps(severe));
                break;
            default:
                (0, catalog_core_1.assertUnreachable)(controlKind);
        }
    }, [chipProps, controlKind, iconProps, props.kind, severe]);
    const triggerElement = triggerElementProps
        ? react_1.default.createElement(TriggerElement, Object.assign({ testId: testId, title: popoverProps.title, onClick: onClick }, triggerElementProps))
        : react_1.default.createElement(react_1.default.Fragment, null);
    if (!triggerElement) {
        return null;
    }
    const popover = renderMode === 'panel' ? triggerElement : (react_1.default.createElement(widgets_1.PopoverWidget, Object.assign({}, popoverProps, { className: (hidePopoverWhenReferenceIsHidden !== null && hidePopoverWhenReferenceIsHidden !== void 0 ? hidePopoverWhenReferenceIsHidden : true) ? (0, typestyle_1.style)(Styles_1.LabelPopoverStyle) : undefined, popoverContent: react_1.default.createElement(Content, { resolved: props, loading: loading }), triggerElement: triggerElement, ref: popoverInstance, testId: controlTestId, width: Styles_1.LabelPopoverWidth })));
    return popover;
}
exports.useControlledPopover = useControlledPopover;
//# sourceMappingURL=useControlledPopover.js.map